module.exports = __webpack_public_path__ + "img/syukyaku-sytem-004.67b4ae5a.jpg";